/**
 * Adds formatting of admins into proper array of objects.
 * @param {array} data - The array of admins to be formatted.
 * @return {array} The formatted array.
 */
export default function getAdmins (data) {
  let newData = []

  for (let i = 0; i < data.length; i++) {
    newData.push({
      id: data[i].admin_id,
      name: data[i].first_name + ' ' + data[i].last_name,
      email: data[i].email,
      level: 0
    })
  }

  return newData
}
